<dt-table-layout *dtDataLoad="displayedEvents$ | async as displayedEvents; error: hasError">
  <div header class="header">
    @if (userIsAdmin$ | async) {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n> Zeige Veranstaltungen </mat-label>
        <mat-select
          [value]="showOnlyEventsUserIsParticipatingIn$.getValue()"
          (selectionChange)="showOnlyEventsUserIsParticipatingIn$.next($event.value)"
        >
          <mat-option [value]="false" i18n> Alle </mat-option>
          <mat-option [value]="true" i18n> Eigene </mat-option>
        </mat-select>
      </mat-form-field>
    }

    @if (canCreateEvents$ | async) {
      <button mat-raised-button color="primary" routerLink="create">
        <mat-icon>add</mat-icon><ng-container i18n>Veranstaltung anlegen</ng-container>
      </button>
    }
  </div>

  <table
    mat-table
    [dataSource]="displayedEvents$"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="activeSort$.value.active"
    [matSortDirection]="activeSort$.value.direction"
    (matSortChange)="activeSort$.next($any($event))"
  >
    <ng-container matColumnDef="submissionStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Abgabe</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon
          [class.active-submission]="row.submissionStatus === 'open'"
          [dtHoverPopover]="submissionPopover"
          dtHoverPopoverPosition="right"
        >
          @switch (row.submissionStatus) {
            @case ('open') {
              <mat-icon>alarm_on</mat-icon>
            }
            @case ('upcoming') {
              <mat-icon>acute</mat-icon>
            }
            @case ('expired') {
              <mat-icon>lock_clock</mat-icon>
            }
          }
        </mat-icon>

        <ng-template #submissionPopover>
          <div class="submission-popover">
            <div class="status">
              @switch (row.submissionStatus) {
                @case ('open') {
                  <ng-container i18n>Abgabe möglich</ng-container>
                }
                @case ('expired') {
                  <ng-container i18n>Abgabezeitraum abgelaufen</ng-container>
                }
                @case ('upcoming') {
                  <ng-container i18n>Abgabezeitraum hat noch nicht begonnen</ng-container>
                }
              }
            </div>
            <table>
              <tr>
                <td>Beginn des Abgabezeitraums</td>
                <td>{{ row.startDate ? (row.startDate | date: 'medium') : '—' }}</td>
              </tr>
              <tr>
                <td>Ende des Abgabezeitraums</td>
                <td>{{ row.endDate ? (row.endDate | date: 'medium') : '—' }}</td>
              </tr>
            </table>
          </div>
        </ng-template>

        @if (!row.questionnaireReleased) {
          <mat-icon matTooltip="Der Fragebogen ist noch nicht veröffentlicht" matTooltipPosition="right" i18n-matTooltip class="error-icon"
            >error</mat-icon
          >
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Code</th>
      <td mat-cell *matCellDef="let row">{{ row.code || '—' }}</td>
    </ng-container>
    <ng-container matColumnDef="registrationCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Teilnehmer</th>
      <td mat-cell *matCellDef="let row">{{ row.registrationCount | number }}</td>
    </ng-container>
    <ng-container matColumnDef="submissionCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Abgaben</th>
      <td mat-cell *matCellDef="let row">{{ row.submissionCount | number }}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Erstellt am</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'short' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="row.id"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Veranstaltungen angelegt.</td>
    </tr>
  </table>

  <dt-table-footer [totalCount]="displayedEvents.length"></dt-table-footer>
</dt-table-layout>
